"use client";

import { Form, useDialogContext, useZodForm } from "@tosize/ui";
import type { PropsWithChildren } from "react";
import { z } from "zod";
import type { LangParams } from "../layout";
import { setPostcode } from "./actions";

interface Props extends LangParams, PropsWithChildren {
	defaultValues?: { postcode?: string };
}

export function PostCodeForm({ lang, children, defaultValues }: Props) {
	const form = useZodForm({
		schema: z.object({
			postcode: z.string().min(1),
		}),
		defaultValues,
	});

	const dialog = useDialogContext();

	return (
		<Form
			className="flex flex-col gap-4"
			form={form}
			onSubmit={async (data) => {
				await setPostcode({ lang, postcode: data.postcode });

				if (dialog?.onOpenChange) {
					dialog.onOpenChange(false);
				}
			}}
		>
			{children}
		</Form>
	);
}
